import React from 'react';
import ReactDOM from 'react-dom/client';
import Modal from 'react-modal';  // React Modal'ı içe aktarın
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

Modal.setAppElement('#root'); // Ana element olarak '#root' kullanılıyor

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
